<template>
    <div>
        <div class="row">
            <div class="col-md-6 d-md-flex align-items-baseline">
                <h1 class="mr-2">List of {{ selectedStatus.label }} Staff</h1>
            </div>
            <!-- SEARCH FUNCTION HERE -->
            <div class="col-md-6 pb-3">
                <input-search-icon
                    v-model="filter.search"
                    @search="searchStaff"
                    :placeholder="'Search Staff'"
                >
                    <template v-slot:before>
                        <dropdown
                            class="pr-2"
                            :btnContent="`Status: ${selectedStatus.label}`"
                            :itemList="allStatus"
                            @selected="statusSelected"
                        ></dropdown>

                        <dropdown
                            class="pr-2"
                            :btnContent="`Role: ${selectedRole.label}`"
                            :itemList="roleList"
                            @selected="roleSelected"
                        ></dropdown>
                    </template>
                </input-search-icon>
            </div>
        </div>
        <div class="card rounded-lg p-3">
            <div class="card-body overflow-auto p-0">
                <div class="table-holder table-responsive">
                    <LoaderList v-if="isLoading" class="w-100" />
                    <table v-else class="table list">
                        <thead>
                            <tr>
                                <th>
                                    <sorting
                                        :order-by="
                                            filter && filter.sortName
                                                ? filter.sortName
                                                : null
                                        "
                                        @sorting="
                                            orderBy =>
                                                sortingData(orderBy, 'fullname')
                                        "
                                        text="Name:"
                                    >
                                    </sorting>
                                </th>
                                <th>Role:</th>
                                <th>Provider:</th>
                                <th>
                                    <sorting
                                        :order-by="
                                            filter && filter.sortEmail
                                                ? filter.sortEmail
                                                : null
                                        "
                                        @sorting="
                                            orderBy =>
                                                sortingData(orderBy, 'email')
                                        "
                                        text="Email:"
                                    >
                                    </sorting>
                                </th>
                                <th>Last Login:</th>
                                <th v-if="selectedStatus.value == 1">
                                    Total Login:
                                </th>
                                <th v-if="selectedStatus.value == 1">
                                    Assigned:
                                </th>
                                <th v-if="selectedStatus.value == 0">
                                    Deactivated:
                                </th>
                                <th v-if="selectedStatus.value == 0">
                                    Deactivated By:
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-if="staffList">
                            <template v-for="staff in staffList">
                                <tr :key="'row-' + staff.id">
                                    <td>
                                        <a
                                            :href="
                                                viewStaffLink + staff.encoded_id
                                            "
                                            class="text-bold text-primary"
                                            >{{ staff.fullname }}</a
                                        >
                                        <input
                                            type="hidden"
                                            :value="staff.id"
                                        />
                                    </td>
                                    <td>{{ staff.role_label }}</td>
                                    <td>
                                        {{ staff.is_provider ? "Yes" : "No" }}
                                    </td>
                                    <td>{{ staff.email }}</td>
                                    <td>
                                        {{
                                            staff.last_login
                                                ? _setDateDisplay(
                                                      staff.last_login
                                                  )
                                                : "--"
                                        }}
                                    </td>
                                    <td v-if="selectedStatus.value == 1">
                                        {{
                                            staff.login_count !== null
                                                ? staff.login_count
                                                : 0
                                        }}
                                    </td>
                                    <td v-if="selectedStatus.value == 1">
                                        {{
                                            staff.create_at != null
                                                ? _carbonDateDisplay(
                                                      staff.create_at
                                                  )
                                                : "--"
                                        }}
                                    </td>

                                    <td v-if="selectedStatus.value == 0">
                                        {{
                                            staff.staff_deactivated_date != null
                                                ? _setDateDisplay(
                                                      staff.staff_deactivated_date
                                                  )
                                                : "--"
                                        }}
                                    </td>
                                    <td v-if="selectedStatus.value == 0">
                                        {{
                                            staff.staff_deactivated_by !== null
                                                ? staff.staff_deactivated_by
                                                : "--"
                                        }}
                                    </td>
                                    <td
                                        v-if="permission.setting_staff_update"
                                        class="text-right small text-nowrap"
                                    >
                                        <spinner
                                            v-if="staff.isLoading"
                                        ></spinner>
                                        <div v-else>
                                            <span v-if="staff.isactive">
                                                <span>
                                                    <a
                                                        :href="
                                                            viewStaffLink +
                                                            staff.encoded_id +
                                                            '?e=1'
                                                        "
                                                        style="cursor: pointer;"
                                                        class="text-decoration-none text-dark font-weight-normal"
                                                        >Edit</a
                                                    ></span
                                                >
                                                |
                                                <span
                                                    style="cursor: pointer;"
                                                    @click="
                                                        !isLoadingModal &&
                                                            deactivateStaff(
                                                                staff.id,
                                                                staff.fullname,
                                                                true
                                                            )
                                                    "
                                                >
                                                    Deactivate
                                                </span>
                                            </span>
                                            <span
                                                v-else
                                                style="cursor: pointer;"
                                                @click="
                                                    !isLoadingModal &&
                                                        deactivateStaff(
                                                            staff.id,
                                                            staff.fullname,
                                                            false
                                                        )
                                                "
                                            >
                                                Reactivate
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                        <tbody v-if="staffList.length == 0">
                            <tr>
                                <td
                                    :colspan="
                                        selectedStatus.value == 'all' ? 6 : 8
                                    "
                                >
                                    <i>No records available</i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <pagination
                :current-page="filter.page"
                :totalPages="totalPages"
                :isLoading="isLoading"
                @change-page="page => changePage(page)"
            />
        </div>
        <modal-is-deactivate-staff
            ref="isDeactivateModal"
            @update-complete="getStaff"
        />
    </div>
</template>
<script>
import { STATUS, checkStatus } from "@/constants/staff";
import staffService from "@/services/staff";

export default {
    components: {
        LoaderList: () => import("@/components/elements/loader-list.vue"),
        ModalIsDeactivateStaff: () =>
            import("@/components/setting-staff/modal-is-deactivate-staff.vue"),
        Sorting: () => import("@/module/commons/sorting.vue"),
        Pagination: () => import("@/components/commons/pagination.vue"),
        Dropdown: () => import("@/components/commons/dropdown.vue"),
        inputSearchIcon: () => import("@/module/commons/input-search-icon.vue"),
        Spinner: () => import("@/components/elements/spinner.vue")
    },
    data() {
        return {
            isLoading: true,
            filter: {
                search: "",
                sortName: "",
                sortEmail: "",
                status: "all",
                role: "",
                perPage: 20,
                page: 1
            },
            permission: [],
            totalPages: 0,
            staffList: [],
            roleList: [],
            role: null,
            status: null,
            isLoadingModal: false
        };
    },
    async created() {
        await this.getRole();
        this.getQueries();
        this.getStaff();
    },
    watch: {
        filter: {
            handler() {
                this.getStaff();
            },
            deep: true
        }
    },
    beforeDestroy() {
        this.$store.commit("staff/reset");
    },
    computed: {
        allStatus() {
            return STATUS;
        },
        selectedStatus() {
            return this.$store.getters["staff/status"];
        },
        selectedRole() {
            return this.$store.getters["staff/role"];
        },
        viewStaffLink() {
            return "/view/settings/users/view/";
        }
    },
    methods: {
        async getRole() {
            let { message, resources } = await staffService.getRoles();
            if (message.code == 200) {
                this.roleList = resources.map(res => {
                    return {
                        label: res.name,
                        value: res.id
                    };
                });
                this.roleList.unshift({ label: "All", value: "" });
            }
        },
        async getStaff() {
            this.isLoading = true;
            const res = await staffService.getStaffList(this.filter);
            const {
                meta,
                data,
                permissions,
                userBalanceQuota
            } = res.data.response.resource;
            if (res.status == 200) {
                this.staffList = data;
                this.totalPages = meta.lastPage;
                this.permission = permissions;
                this.$store.commit("staff/setQuota", userBalanceQuota);
            }
            this.isLoading = false;
        },
        getQueries() {
            const routeQuery = this.$route.query;
            if (routeQuery) {
                if (routeQuery.status) {
                    let findStatus = checkStatus(routeQuery.status);
                    this.filter.status = findStatus.value;
                    this.resetFilter();

                    this.$store.commit("staff/setStatus", findStatus);
                }

                if (routeQuery.role) {
                    let role = this.roleList.find(
                        res => res.value == routeQuery.role
                    );

                    if (role !== undefined) {
                        this.filter.role = role.value;
                        this.resetFilter();
                        this.$store.commit("staff/setRole", role);
                    }
                }
            }
        },
        sortingData(orderBy, col) {
            this.filter.page = 1;
            if (col == "fullname") {
                this.filter.sortName = orderBy;
                this.filter.sortEmail = "";
            } else if (col == "email") {
                this.filter.sortName = "";
                this.filter.sortEmail = orderBy;
            }
        },
        changePage(page) {
            this.filter.page = page;
        },
        statusSelected(data) {
            this.$store.commit("staff/setStatus", data);
            this.filter.status = data.value;
            this.resetFilter();
            this.$router.push(
                `/settings/users?status=${data.route}&role=${this.selectedRole.value}`
            );
        },
        roleSelected(data) {
            this.$store.commit("staff/setRole", data);
            this.filter.role = data.value;
            this.resetFilter();
            this.$router.push(
                `/settings/users?status=${this.selectedStatus.route}&role=${data.value}`
            );
        },
        searchStaff(keyword) {
            this.filter.search = keyword;
            this.resetFilter();
        },
        async deactivateStaff(id, name, deactivate) {
            this.isLoadingModal = true;
            const index = this.staffList.findIndex(staff => staff.id === id);
            if (index !== -1) {
                this.$set(this.staffList[index], "isLoading", true);
                await this.$refs.isDeactivateModal.open(id, name, deactivate);
                this.$set(this.staffList[index], "isLoading", false);
            }
            this.isLoadingModal = false;
        },
        resetFilter() {
            this.filter.sortEmail = "";
            this.filter.sortName = "";
            this.filter.page = 1;
        }
    }
};
</script>
